"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDecimalsCount = void 0;
function getDecimalsCount(max, format) {
    const numberOfDigits = format.replace(/\./, '').length;
    const fractionDigits = format.split('.')[1].length;
    return (Math.max(String(max.toFixed(0)).length, numberOfDigits - fractionDigits) +
        fractionDigits);
}
exports.getDecimalsCount = getDecimalsCount;
